import { PruHttpService } from './pru-http.service';
import { GenericService } from './generic.service';
import { CookieService } from 'ngx-cookie-service';
import { shareReplay } from "rxjs/operators";
import { ReplaySubject } from "rxjs/ReplaySubject";
import * as i0 from "@angular/core";
import * as i1 from "./pru-http.service";
import * as i2 from "./generic.service";
import * as i3 from "ngx-cookie-service/cookie-service/cookie.service";
var PznService = /** @class */ (function () {
    function PznService(pruHttp, _genericService, _cookieService) {
        this.pruHttp = pruHttp;
        this._genericService = _genericService;
        this._cookieService = _cookieService;
        this.linkCTAObs = new ReplaySubject();
        this.linkCTAObs$ = this.linkCTAObs.asObservable();
        this.crypto = window.crypto;
    }
    PznService.prototype.getPZNData = function () {
        /* recommend for you service */
        var customHeaders = {
            "appName": "DASHBOARD",
            "noOfSlots": "11",
            "noOfPersonalizedSlots": "5",
            "noOfCTAPersonalized": "2",
            "noOfCTAPinned": "2",
            "noOfPinned": "2",
            "contentSection": "RecommendedArticles",
            "pageName": "FOR_YOU",
            "byContentType": "ToolsCTA,Article,Album,Tool,Video, Infographic, CTA, Quiz, Webinar",
            "fl": "articleLink,ctaLink,ctaText,thumbnailImg,shortDescription,title,content_type,solution,pinned,category"
        };
        var queryParamForPzn = this._cookieService.get("X-PruGlobalSessionID");
        //set globalsessionid cookie in case it's not available
        if (environment.PUBLIC_RENDER_DOMAIN && !queryParamForPzn) {
            var crypto_1 = this.crypto || window['msCrypto'];
            var cookieValue = crypto_1.getRandomValues(new Uint32Array(1))[0];
            var date = new Date();
            date.setTime(date.getTime() + (60 * 60 * 1000));
            var expires = "expires=" + date.toUTCString();
            document.cookie = 'X-PruGlobalSessionID=' + cookieValue + ';' + expires + ';domain=.prudential.com; path=/; SameSite=Lax;Secure;';
            queryParamForPzn = 'pzn' + cookieValue;
        }
        var url = '/api/co/secure/recommend/v1/recommend/';
        return this.pruHttp.get(url, 'PznService', { "visitorId": queryParamForPzn }, customHeaders).pipe(shareReplay());
        ;
    };
    PznService.ngInjectableDef = i0.defineInjectable({ factory: function PznService_Factory() { return new PznService(i0.inject(i1.PruHttpService), i0.inject(i2.GenericService), i0.inject(i3.CookieService)); }, token: PznService, providedIn: "root" });
    return PznService;
}());
export { PznService };
